import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  loadingModal: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    '& .MuiDialog-paper': {
      background: 'none',
      boxShadow: 'none',
    },
  },
});

export default useStyles;
